import { useTranslation } from 'react-i18next';

import { SendHorizontal } from 'lucide-react';

interface ChatInputProps {
    value: string;
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    onSubmit: (e: React.FormEvent) => void;
    isDisabled: boolean;
    isLoading: boolean;
}

export const ChatInput = ({ value, onChange, onSubmit, isDisabled, isLoading }: ChatInputProps) => {
    const { t } = useTranslation();

    return (
        <form onSubmit={onSubmit} className="w-full">
            <div className="flex flex-col gap-2 h-[59px] border border-chatbot-line py-[6px] px-[10px] rounded-[10px] focus-within:border-point">
                <input
                    className="w-full outline-0 text-sm bg-transparent"
                    value={value}
                    onChange={onChange}
                    placeholder={t('ai.chatbot.input_placeholder')}
                    disabled={isDisabled}
                />
                <div className="w-full flex justify-end">
                    <button
                        type="submit"
                        disabled={isDisabled || !value.trim()}
                        className="hover:bg-gray-100 dark:hover:bg-gray-800 transition-colors disabled:cursor-not-allowed"
                    >
                        {isLoading ? (
                            <div className="h-4 w-4 animate-spin rounded-full border-2 border-background border-t-foreground" />
                        ) : (
                            <SendHorizontal
                                className="w-[18px] h-[18px]"
                                fill={value.trim() && !isDisabled ? 'hsl(var(--point))' : 'hsl(var(--text-500))'}
                                stroke={value.trim() && !isDisabled ? 'hsl(var(--point))' : 'hsl(var(--text-500))'}
                            />
                        )}
                    </button>
                </div>
            </div>
        </form>
    );
};
